import { createFeature, createReducer, on } from "@ngrx/store";
import { UserState } from "./user.model";
import { UserActions } from "./user.actions";

const initialState: UserState = {
    currentUser: null,
    loading: false,
    error: null
}

export const userFeature = createFeature({
    name: 'user',
    reducer: createReducer(
        initialState,
        on(UserActions.getCurrentUser, (state) => ({ 
            ...state, 
            loading: true,
            error: null
        })),
        on(UserActions.setCurrentUser, (state, { user }) => ({ 
            ...state,
            currentUser: user,
            loading: false,
            error: null
        }))
    )
})